import gsap from 'gsap';

const PX_PER_SECOND = 45;

const getSourceItems = (viewportEl) => {
	const source = viewportEl.querySelector('.js-hero-logos-source');
	if (!source) {
		return [];
	}

	return [...source.content.querySelectorAll('.hero__logos-item')];
};

const buildFilledGroup = (sourceItems, minWidth, track) => {
	const group = document.createElement('ul');
	group.className = 'hero__logos-group';
	track.appendChild(group);

	const appendBatch = () => {
		sourceItems.forEach((item) => {
			const clone = item.cloneNode(true);
			clone.querySelectorAll('img').forEach((img) => {
				img.loading = 'eager';
			});
			group.appendChild(clone);
		});
	};

	appendBatch();

	if (sourceItems.length) {
		while (group.offsetWidth < minWidth) {
			appendBatch();
		}
	}

	return group;
};

const populateTrack = (track, viewportEl) => {
	const sourceItems = getSourceItems(viewportEl);
	if (!sourceItems.length) {
		return false;
	}

	const minWidth = viewportEl.offsetWidth;

	track.replaceChildren();

	const primary = buildFilledGroup(sourceItems, minWidth, track);
	const duplicate = primary.cloneNode(true);
	duplicate.setAttribute('aria-hidden', 'true');

	track.append(primary, duplicate);

	return true;
};

const startMarqueeTween = (track) => {
	const groups = track.querySelectorAll('.hero__logos-group');
	if (groups.length < 2) {
		return null;
	}

	const distance = () => groups[0].offsetWidth;

	return gsap.fromTo(
		track,
		{ x: 0 },
		{
			x: () => -distance(),
			duration: () => distance() / PX_PER_SECOND,
			ease: 'none',
			repeat: -1,
		},
	);
};

const bindMarquee = (track, viewportEl) => {
	if (!populateTrack(track, viewportEl)) {
		return null;
	}

	let tween = null;

	const start = () => {
		tween?.kill();
		gsap.set(track, { clearProps: 'x' });
		tween = startMarqueeTween(track);
	};

	const rebuild = () => {
		populateTrack(track, viewportEl);
		if (tween) {
			start();
		}
	};

	const ro = new ResizeObserver(rebuild);
	ro.observe(viewportEl);

	return { start, cleanup: () => {
		ro.disconnect();
		tween?.kill();
		gsap.set(track, { clearProps: 'x' });
	} };
};

export const initHeroLogos = () => {
	const tracks = document.querySelectorAll('.js-hero-logos-track');
	if (!tracks.length) {
		return;
	}

	const marquees = [];

	tracks.forEach((track) => {
		const viewport = track.closest('.hero__logos-viewport');
		if (!viewport) {
			return;
		}

		const marquee = bindMarquee(track, viewport);
		if (marquee) {
			marquees.push(marquee);
		}
	});

	const cleanups = [];

	gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', () => {
		marquees.forEach((marquee) => marquee.start());

		return () => {
			marquees.forEach((marquee) => marquee.cleanup());
		};
	});
};
